import { ButtonBase, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: '20px',
        width: '100%',
        padding: theme.spacing(3),
        background: theme.palette.ensightful.shades[0],
        boxShadow: theme.palette.ensightful.shadows[1],
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
        '&:hover, &:active': {
            margin: '-1px',
            width: 'calc(100% + 2px)',
            height: 'calc(100% + 2px)',
        },
        '&:hover': {
            border: `2px solid ${theme.palette.ensightful.primary[500]}`,
        },
        '&:active': {
            border: `2px solid ${theme.palette.ensightful.primary[700]}`,
        },
    };
});

export default forwardRef(({ children, ...rest }, ref) => {
    return (
        <CustomButtonBase ref={ref} component={'div'} role={'presentation'} {...rest}>
            {children}
        </CustomButtonBase>
    );
});
